import { Component, Input, OnInit } from '@angular/core';
import { OpportunitiesService } from 'src/app/services/opportunitiesPage/opportunities.service';
import { OpportunityHistory } from 'src/app/services/opportunitiesPage/opportunities';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesService, Users } from 'src/app/shared/services/sales.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  @Input() hideComponent: boolean = false;

  constructor(private opportunitiesService: OpportunitiesService,private route: ActivatedRoute,   private router: Router, private salesService: SalesService) { }

  historyList : OpportunityHistory[];
  opportunityId : number;
  noRecords : boolean = true;
  public salesUsers: Users[];
  public errorMsg;

  
  async ngOnInit(): Promise<void> {
    await this.getAllSalesUsers();
    await this.fetchOpportunityId();
    await this.retrieveHistory();
  }

  async fetchOpportunityId(){

    this.route
      .queryParams
      .subscribe(params => {
        // console.log("params coming from previous page.............");
        // console.log(params);
        // Defaults to -1 if no query param provided.
        this.opportunityId = +params['id'] || -1;
      });
  }

  async retrieveHistory() {
    await this.opportunitiesService.retrieveOpportunityHistory(this.opportunityId).toPromise().then(response =>
      {
        //console.log(response);
        this.historyList = response;   
        
        if (this.historyList.length>0){
          this.noRecords = false;
        }

        response.forEach(data => {
          //console.log(data);
          populateUser(data.user,this.salesUsers,data);
        });
      
    });
  }

  async getAllSalesUsers() {
    return this.salesService.retrieveMainData().toPromise().then(
      response =>{
        //////console.log("getAllUsersMainData : "+ response);
        //////console.log(response); 
        this.salesUsers = response;
      },
      error => this.errorMsg = error
     );
  }
}


function populateUser(userId: number, salesUsers: Users[], opportunityHistory: OpportunityHistory) {
  for (var j = 0; j < salesUsers.length; j++) {
    var option = salesUsers[j];
    //console.log(option)
    if (option.userId === userId) {
      opportunityHistory.userName = option.firstName +" " + option.lastName;
      break;
    }
  }
}